import { render, staticRenderFns } from "./ApproveDocumentModal.vue?vue&type=template&id=2d7eb8f7&scoped=true&"
import script from "./ApproveDocumentModal.vue?vue&type=script&lang=js&"
export * from "./ApproveDocumentModal.vue?vue&type=script&lang=js&"
import style0 from "./ApproveDocumentModal.vue?vue&type=style&index=0&id=2d7eb8f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7eb8f7",
  null
  
)

export default component.exports